module.exports = __webpack_public_path__ + "img/942-4f2108.png";